import { useEffect, useState } from "react";
import { Checkbox, Form, Input, Modal, Typography } from "antd";
import { useDispatch } from "react-redux";
import LookupTable from "redux/models/lookupTable.js";
import { clientTabsConfig } from "config/tabsConfig";
import { noTrailingSpaceAllowedRule } from "utilities/generalUtility";
import Scrollbars from "react-custom-scrollbars-2";
import { customFormatSettingTime } from "utilities/dateUtility";
import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder";

const { Title, Paragraph } = Typography;

export default function ClientLookupTableModal({
  isVisible,
  setIsModalVisible,
  editData,
  setEditData,
  title,
  clientId,
  table,
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const selectedTab = clientTabsConfig[table];

  const [history, setHistory] = useState([]);

  const afterModalClose = () => {
    form.resetFields();
    setEditData({});
    setHistory([]);
  };
  const addLookUpData = async (name, isVisible) => {
    setIsLoading(true);

    try {
      await dispatch(
        LookupTable.addClientData(
          selectedTab.reduxKey,
          selectedTab.apiEndPoint,
          {
            name,
            isVisible: isVisible ? 0 : 1,
          },
          clientId,
        ),
      );
      setIsLoading(false);
      setIsModalVisible(false);
      form.resetFields();
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const getHistory = async () => {
    const payload = {
      type: selectedTab.table,
      entityId: editData.id, // look table row id
    };
    try {
      const res = await LookupTable.getLookupHistory(payload);
      setHistory(res);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (editData.id) {
      form.setFieldsValue({
        name: editData?.name,
        isVisible: editData?.isVisible ? 0 : 1,
      });
      getHistory();
    }
  }, [form, editData]);

  const editLookUpData = async (name, isVisible) => {
    const dataWasChanged =
      name !== editData.name || !!isVisible === !!editData.isVisible;

    setIsLoading(true);
    try {
      dataWasChanged &&
        (await dispatch(
          LookupTable.editClientData(
            selectedTab.reduxKey,
            selectedTab.apiEndPoint,
            editData.id,
            {
              name,
              isVisible: isVisible ? 0 : 1,
            },
            clientId,
          ),
        ));
      setIsLoading(false);
      setIsModalVisible(false);
      form.resetFields();
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onFinish = (values) => {
    if (Object.keys(editData).length) {
      editLookUpData(values.name, values.isVisible);
    } else {
      addLookUpData(values.name, values.isVisible);
    }
  };

  return (
    <Modal
      forceRender
      centered
      open={isVisible}
      closeIcon={<i className="icon-closeable" />}
      okText={Object.keys(editData).length ? "Update" : "Add"}
      className="s2-theme-style"
      wrapClassName="vertical-center-modal"
      title={
        Object.keys(editData).length ? `Edit ${title}` : `Add New ${title}`
      }
      okButtonProps={{ loading: isLoading }}
      onOk={form.submit}
      afterClose={afterModalClose}
      onCancel={() => setIsModalVisible(false)}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: "Name is required." },
            noTrailingSpaceAllowedRule(),
          ]}
        >
          <Input placeholder="Enter name" />
        </Form.Item>
        <Form.Item name="isVisible" valuePropName="checked">
          <Checkbox>Archived </Checkbox>
        </Form.Item>
      </Form>
      <div className="settingHistoryWrap">
        <Scrollbars style={{ height: 270 }}>
          {history.length ? (
            history.map((item, i, source) => (
              <div key={item.id} className="settingHistoryDetail">
                <div className="settingAmountHistory">
                  <div className="clientName">
                    <Title level={5}>
                      {i === history?.length - 1 ? "Created By" : "Updated By"}:
                    </Title>
                    <Paragraph>{item.userName}</Paragraph>
                  </div>
                  <div className="clientName">
                    <Title level={5}>
                      {i === history?.length - 1
                        ? "Created Date"
                        : "Updated Date"}
                      :
                    </Title>
                    <Paragraph>
                      {customFormatSettingTime(item.createdAt, true)}
                    </Paragraph>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <EmptyPlaceholder />
          )}
        </Scrollbars>
      </div>
    </Modal>
  );
}
